import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { AccordionComponent } from './components/accordion/accordion.component';
import { ComboComponent } from './components/combo/combo.component';
import {
  NgbCollapseModule,
  NgbTypeaheadModule,
} from '@ng-bootstrap/ng-bootstrap';
import { FormsModule } from '@angular/forms';

@NgModule({
  declarations: [AccordionComponent, ComboComponent],
  imports: [
    CommonModule,
    TranslateModule,
    NgbTypeaheadModule,
    FormsModule,
    NgbCollapseModule,
  ],
  exports: [TranslateModule, ComboComponent, AccordionComponent, FormsModule],
})
export class SharedModule {}
